<template>
  <iframe
    style="
            position:absolute;
            width: 87%;
            height: 100%;
              overflow: hidden;
              border-radius: 4px;
              box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
            "
    :src="link"
    frameborder="0"
    allowFullScreen="true"
  ></iframe>
</template>
<script>
export default {
  name: "IFrame",
  data() {
    return {
      link: null,
    };
  },
  beforeMount(){
    this.link = this.$router.currentRoute.meta.link;
  }
};
</script>